import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Paper, Box, Typography } from "@mui/material";
import axios from "axios";
import { format } from "date-fns";
import { differenceInDays, parseISO } from "date-fns";
import { Tooltip } from "@mui/material";
import { CheckCircle, Warning, Error } from "@mui/icons-material";

const DataTable = ({ endpoint, branches }) => {

  let branch_code_from_local_storage = localStorage.getItem("currentSelectedDepartment");

  const [expandedRow, setExpandedRow] = useState()

  const handleRowClick = (valuefromClick) => {
    console.log("handleRowClick", valuefromClick)
    setExpandedRow(prev => (prev === valuefromClick.id ? null : valuefromClick.id));
  };

  console.log("endpoint in DATATABLE >>>", endpoint)

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const pageSize = 20;

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits for month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure two digits for day
    return `${year}-${month}-${day}`;
  };

  const todayDate = getTodayDate();

  useEffect(() => {
    fetchTableData();
  }, [endpoint]);


  useEffect(() => {
    console.log('selectedbranchCode', selectedBranchCode)

    const selected = branches?.find(
      (branch) => branch.DEPTNO === selectedBranchCode
    );
    setSelectedBranch(selected);
    console.log('selected', selected)

    fetchTableData();
  }, [selectedBranchCode])

  useEffect(() => {

    // Automatically select the first branch
    if (branches.length > 0) {
      //   setSelectedBranch(branchArray[0].DEPTNO);
      setSelectedBranch(branches[0]);
      setSelectedBranchCode(branches[0].DEPTNO)
    }

  }, [branches])

  const fetchTableData = async () => {
    try {

      let apiUrl = `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${branch_code_from_local_storage}/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`

      console.log("apiUrl >>>", apiUrl)

      const response = await axios.get(
        // `https://cubixweberp.com:213/api/HRDashboard/SUNRISE/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
        apiUrl

      );
      const data = response.data;
      console.log('data', response.data)
      if (endpoint === "CRM_CUSTOMER_AQUI") {
        console.log("CRM_SALESMAN_PERFORM data:", data);
      }
      setTableData(data);
    } catch (error) {
      console.error("Error while fetching table data", error);
    }
  };

  const columns =
    endpoint && endpoint === "CRM_TOP100ORDER_PRODUCTS"
      ? [
        // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
        {
          field: "code", headerName: "Code", flex: 1, sortable: false, renderCell: (params) => {
            if (params.row.isExpanded) {
              return (
                <Box sx={{ padding: 1, columnSpan: 20 }}>

                  {params.row.content}

                </Box>
              );
            }
            return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
          },
        },
        // { field: "desc", headerName: "Description", flex: 5, sortable: false },
        { field: "totalRevenue", headerName: "Total Revenue", width: 110, type: 'number', sortable: false },
        // { field: "totalSold", headerName: "Total Sold", flex: 0.5, type: 'number', sortable: false },
      ]
      : endpoint === "CRM_CUST_LIFETIME_VALUE"
        ? [
          // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
          // { field: "account", headerName: "Account", flex: 1, sortable: false },
          {
            field: "accountDescription",
            headerName: "Account Description",
            flex: 2,
            sortable: false,
            renderCell: (params) => {
              if (params.row.isExpanded) {
                return (
                  <Box sx={{ padding: 1, columnSpan: 20 }}>

                    {params.row.content}

                  </Box>
                );
              }
              return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
            },
          },
          // { field: "totalSpent", headerName: "Total Spent", width: 110, type: 'number', sortable: false },
          // { field: "totalOrders", headerName: "Total Orders", flex: 0.5, type: 'number', sortable: false },
          {
            field: "avgOrderValue",
            headerName: "Average Order Value",
            flex: 1,
            type: 'number',
            sortable: false
          },
        ]
        : endpoint === "DAILYSALES_DEPT"
          ? [
            // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
            // {
            //   field: "deptno", headerName: "Dept No", flex: 0.5, sortable: false, renderCell: (params) => {
            //     if (params.row.isExpanded) {
            //       return (
            //         <Box sx={{ padding: 1, columnSpan: 20 }}>

            //           {params.row.content}

            //         </Box>
            //       );
            //     }
            //     return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
            //   },
            // },
            // { field: "deptnodesc", headerName: "Department Description", flex: 1.5, sortable: false },
            {
              field: "SaleDate",
              headerName: "Sale Date",
              flex: 1, renderCell: (params) => {
                if (params.row.isExpanded) {
                  return (
                    <Box sx={{ padding: 1, columnSpan: 20 }}>

                      {params.row.content}

                    </Box>
                  );
                }
                return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
              },
              sortable: false
            },
            // { field: "SalesCount", headerName: "Sales Count", width: 110, type: 'number', sortable: false },
            { field: "TotalSales", headerName: "Total Sales", flex: 1, type: 'number', sortable: false },
            // { field: "AvgOrderValue", headerName: "Avg. Order Value", flex: 1, type: 'number', sortable: false },
          ]

          : endpoint === "MONTHLYSALES_DEPT"
            ? [
              // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
              // { field: "deptno", headerName: "Dept No", flex: 0.5, sortable: false },
              {
                field: "deptnodesc", headerName: "Department Description", flex: 1.5, sortable: false,
                renderCell: (params) => {
                  if (params.row.isExpanded) {
                    return (
                      <Box sx={{ padding: 1, columnSpan: 20 }}>

                        {params.row.content}

                      </Box>
                    );
                  }
                  return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                },
              },
              // {
              //   field: "SaleMonth",
              //   headerName: "Sale Month",
              //   flex: 1,
              //   // valueGetter: (params) => {
              //   //   const [year, month] = params.row?.SaleMonth?.split("-") ?? [];
              //   //   return month && year ? `${month}-${year}` : "";
              //   // ,sortable: false},
              //   sortable: false
              // },
              // { field: "SalesCount", headerName: "Sales Count", width: 110, type: 'number', sortable: false },
              { field: "TotalSales", headerName: "Total Sales", flex: 1, type: 'number', sortable: false },
              // { field: "AvgOrderValue", headerName: "Avg. Order Value", flex: 1, type: 'number', sortable: false },
            ]

            : endpoint === "SAMAN_PERF_SUMM"
              ? [
                // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false }, ,
                // { field: "sman_key", headerName: "Salesman Code", flex: 0.7, sortable: false }, ,
                {
                  field: "sman_name", headerName: "Salesman Name", flex: 1.5, sortable: false, renderCell: (params) => {
                    if (params.row.isExpanded) {
                      return (
                        <Box sx={{ padding: 1, columnSpan: 20 }}>

                          {params.row.content}

                        </Box>
                      );
                    }
                    return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                  },
                }, ,
                // { field: "email", headerName: "Email", flex: 1.5, sortable: false }, ,
                // { field: "phoneno", headerName: "Phone Number", flex: 1, sortable: false }, ,
                // { field: "SalesCount", headerName: "Sales Count", width: 110, type: 'number', sortable: false }, ,
                { field: "TotalSales", headerName: "Total Sales", flex: 1, type: 'number', sortable: false }, ,
                {
                  field: "LastSaleDate",
                  headerName: "Last Sale Date",
                  flex: 1,
                  type: 'number',
                  // valueGetter: (params) =>
                  //   new Date(params.row?.LastSaleDate).toLocaleDateString("en-GB"),
                  sortable: false
                }, ,

                // { field: "AvgSaleAmount", headerName: "Avg. Sale Amount", type: 'number', flex: 1, sortable: false }, ,
              ]
              : endpoint === "6MONTH_SALES_COMP"
                ? [
                  // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                  {
                    field: "Current6MonthsSales",
                    headerName: "Current 6 Months Sales",
                    flex: 1,
                    // valueFormatter: (params) => params.value?.toLocaleString("en-IN", {
                    //   style: "currency",
                    //   currency: "AED",
                    //   minimumFractionDigits: 2,
                    // }),
                    renderCell: (params) => {
                      if (params.row.isExpanded) {
                        return (
                          <Box sx={{ padding: 1, columnSpan: 20 }}>

                            {params.row.content}

                          </Box>
                        );
                      }
                      return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                    },
                    sortable: false
                  },
                  // {
                  //   field: "Previous6MonthsSales",
                  //   headerName: "Previous 6 Months Sales",
                  //   flex: 1,
                  //   valueFormatter: (params) => params.value?.toLocaleString("en-IN", {
                  //     style: "currency",
                  //     currency: "AED",
                  //     minimumFractionDigits: 2,
                  //   }),
                  //   sortable: false
                  // },
                  {
                    field: "GrowthPercent",
                    headerName: "Growth (%)",
                    flex: 0.7,
                    // valueFormatter: (params) => `${params.value?.toFixed(2)}%`,
                    // valueFormatter: (params) => params.value?.toLocaleString("en-IN", {
                    //   style: "currency",
                    //   currency: "AED",
                    //   minimumFractionDigits: 2,
                    // }),
                    sortable: false
                  },
                ]
                : endpoint === "MONTH_SALES_COMP"
                  ? [

                    {
                      field: "SaleMonth",
                      headerName: "Sale Month",
                      flex: 1,
                      sortable: false,
                      renderCell: (params) => {
                        if (params.row.isExpanded) {
                          return (
                            <Box sx={{ padding: 1, columnSpan: 20 }}>

                              {params.row.content}

                            </Box>
                          );
                        }
                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                      },
                    },
                    // {
                    //   field: "SalesCount",
                    //   headerName: "Sales Count",
                    //   width: 110,
                    //   type: "number",
                    //   sortable: false
                    // },
                    {
                      field: "TotalSales",
                      headerName: "Total Sales",
                      flex: 1,
                      type: "number",
                      renderCell: (params) => {

                        return (
                          <Box sx={{ paddingRight: 1 }}>

                            {params.value}

                          </Box>
                        );

                      },

                      // valueFormatter: (params) =>
                      //   params.value?.toLocaleString("en-IN", {
                      //     style: "currency",
                      //     currency: "AED",
                      //     minimumFractionDigits: 2,
                      //   }),
                      sortable: false
                    },
                    // {
                    //   field: "AvgSaleAmount",
                    //   headerName: "Avg. Sale Amount",
                    //   width: 110,
                    //   type: "number",

                    //   valueFormatter: (params) =>
                    //     params.value?.toLocaleString("en-IN", {
                    //       style: "currency",
                    //       currency: "AED",
                    //       minimumFractionDigits: 2,
                    //     }),
                    //   sortable: false
                    // },
                    // {
                    //   field: "PrevMonthSales",
                    //   headerName: "Prev Month Sales",
                    //   width: 140,
                    //   type: "number",

                    //   // valueFormatter: (params) =>
                    //   //   params?.value != null
                    //   //     ? params?.value.toLocaleString("en-IN", {
                    //   //       style: "currency",
                    //   //       currency: "AED",
                    //   //       minimumFractionDigits: 2,
                    //   //     })
                    //   //     : "-",
                    //   sortable: false
                    // },
                    // {
                    //   field: "GrowthPercent",
                    //   headerName: "Growth (%)",
                    //   width: 140,
                    //   type: "number",

                    //   // valueFormatter: (params) =>
                    //   //   params?.value != null ? `${params?.value.toFixed(2)}%` : "-",
                    //   sortable: false,
                    //   renderCell: (params) => (
                    //     <div className="px-2">{params.value}</div>
                    //   )
                    // },
                  ]
                  : endpoint === "MONTH_LEAD_PIPELINE"
                    ? [
                      // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                      {
                        field: "lead_stage", headerName: "Lead Stage", flex: 1, sortable: false,
                        renderCell: (params) => {
                          if (params.row.isExpanded) {
                            return (
                              <Box sx={{ padding: 1, columnSpan: 20 }}>

                                {params.row.content}

                              </Box>
                            );
                          }
                          return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                        }
                      },
                      { field: "Leads_CurrentMonth", headerName: "Current Month Leads", flex: 1, type: "number", sortable: false },
                      // { field: "Leads_PreviousMonth", headerName: "Previous Month Leads", width: 110, type: "number", sortable: false },
                      // {
                      //   field: "BookedAmt_CurrentMonth",
                      //   headerName: "Booked Amt (Current)",
                      //   flex:1,
                      //   type: "number",
                      //   // valueFormatter: (params) =>
                      //   //   params.value?.toLocaleString("en-IN", {
                      //   //     style: "currency",
                      //   //     currency: "AED",
                      //   //     minimumFractionDigits: 2,
                      //   //   })
                      //    sortable: false
                      // },
                      // {
                      //   field: "BookedAmt_PreviousMonth",
                      //   headerName: "Booked Amt (Previous)",
                      //   width: 110,
                      //   type: "number",
                      //   valueFormatter: (params) =>
                      //     params.value?.toLocaleString("en-IN", {
                      //       style: "currency",
                      //       currency: "AED",
                      //       minimumFractionDigits: 2,
                      //     })
                      //   , sortable: false
                      // },
                      // {
                      //   field: "GrowthPercent",
                      //   headerName: "Growth (%)",
                      //   width: 140,
                      //   type: "number"
                      //   // valueFormatter: (params) =>
                      //   //   params?.value != null ? `${params?.value.toFixed(2)}%` : "-",
                      //   , sortable: false
                      // },
                    ]

                    : endpoint === "New_Client_Acquisition_6mon"
                      ? [
                        // { field: "id", headerName: "Sl No", flex: 0.3 },
                        {
                          field: "Current6MonthsNewClients",
                          headerName: "New Clients (Current 6 Months)",
                          flex: 1.5
                          , sortable: false,
                          renderCell: (params) => {
                            if (params.row.isExpanded) {
                              return (
                                <Box sx={{ padding: 1, columnSpan: 20 }}>

                                  {params.row.content}

                                </Box>
                              );
                            }
                            return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                          },
                        },
                        {
                          field: "Current6MonthsRevenue",
                          headerName: "Revenue (Current 6 Months)",
                          flex: 1.5
                          // valueFormatter: (params) =>
                          //   params.value?.toLocaleString("en-IN", {
                          //     style: "currency",
                          //     currency: "AED",
                          //     minimumFractionDigits: 2,
                          //   })
                          , sortable: false
                        },
                        // {
                        //   field: "Previous6MonthsNewClients",
                        //   headerName: "New Clients (Previous 6 Months)",
                        //   flex: 1.5
                        //   , sortable: false
                        // },
                        // {
                        //   field: "Previous6MonthsRevenue",
                        //   headerName: "Revenue (Previous 6 Months)",
                        //   flex: 1.5,
                        //   valueFormatter: (params) =>
                        //     params?.value?.toLocaleString("en-IN", {
                        //       style: "currency",
                        //       currency: "AED",
                        //       minimumFractionDigits: 2,
                        //     })
                        //   , sortable: false
                        // },
                      ]
                      : endpoint === "Top_50_Selling_Products"
                        ? [
                          // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                          // { field: "code", headerName: "Product Code", flex: 0.8, sortable: false },
                          {
                            field: "desc",
                            headerName: "Product Description",
                            flex: 2.5,
                            // renderCell: (params) => (
                            //   <div className="line-clamp-2 overflow-hidden">{params.value}</div>
                            // ),
                            renderCell: (params) => {
                              if (params.row.isExpanded) {
                                return (
                                  <Box sx={{ padding: 1, columnSpan: 20 }}>

                                    {params.row.content}

                                  </Box>
                                );
                              }
                              return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                            }
                            , sortable: false
                          },
                          {
                            field: "Current6MonthsSales",
                            headerName: "Sales (Current 6 Months)",
                            flex: 1.2,
                            type: "number"
                            // valueFormatter: (params) =>
                            //   params.value?.toLocaleString("en-IN", {
                            //     style: "currency",
                            //     currency: "AED",
                            //     minimumFractionDigits: 2,
                            //   })
                            , sortable: false
                          },
                          // {
                          //   field: "Previous6MonthsSales",
                          //   headerName: "Sales (Previous 6 Months)",
                          //   flex: 1.2,
                          //   type: "number",
                          //   valueFormatter: (params) =>
                          //     params?.value?.toLocaleString("en-IN", {
                          //       style: "currency",
                          //       currency: "AED",
                          //       minimumFractionDigits: 2,
                          //     })
                          //   , sortable: false
                          // },
                        ]
                        : endpoint === "Monthly_Expense_analysis"
                          ? [
                            // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                            // { field: "account", headerName: "Account", flex: 0.8, sortable: false },
                            {
                              field: "accdesc", headerName: "Account Description", flex: 2, sortable: false, renderCell: (params) => {
                                if (params.row.isExpanded) {
                                  return (
                                    <Box sx={{ padding: 1, columnSpan: 20 }}>

                                      {params.row.content}

                                    </Box>
                                  );
                                }
                                return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                              },
                            },
                            // { field: "2025-01", headerName: "Jan 2025", width: 110, type: "number", sortable: false },
                            // { field: "2025-02", headerName: "Feb 2025", width: 110, type: "number", sortable: false },
                            // { field: "2025-03", headerName: "Mar 2025", width: 110, type: "number", sortable: false },
                            // { field: "2025-04", headerName: "Apr 2025", width: 110, type: "number", sortable: false },
                            // { field: "2025-05", headerName: "May 2025", width: 110, type: "number", sortable: false },
                            // { field: "2025-06", headerName: "Jun 2025", width: 110, type: "number", sortable: false },
                            {
                              field: "Total",
                              headerName: "Total",
                              width: 110,
                              type: "number",
                              valueGetter: (params) => {
                                // Calculate total of all months, ignoring nulls
                                const months = ["2025-01", "2025-02", "2025-03", "2025-04", "2025-05", "2025-06"];
                                return months.reduce((sum, month) => sum + (params?.row[month] ?? 0), 0);
                              },
                              sortable: false
                            },
                          ]
                          : endpoint === "Sales_Growth_Rate"
                            ? [
                              // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                              {
                                field: "SaleMonth", headerName: "Sale Month", flex: 1, sortable: false, renderCell: (params) => {
                                  if (params.row.isExpanded) {
                                    return (
                                      <Box sx={{ padding: 1, columnSpan: 20 }}>

                                        {params.row.content}

                                      </Box>
                                    );
                                  }
                                  return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                },
                              },
                              { field: "TotalSales", headerName: "Total Sales", flex: 1, type: "number", sortable: false },
                              // { field: "PrevMonthSales", headerName: "Previous Month Sales", width: 110, type: "number", sortable: false },
                              // {
                              //   field: "GrowthPercent",
                              //   headerName: "Growth Percent (%)",
                              //   width: 110,
                              //   type: "number",
                              //   // valueFormatter: (params) =>
                              //   //   params?.value !== null && params?.value !== undefined
                              //   //     ? `${params?.value.toFixed(2)}%`
                              //   //     : "N/A",
                              //   sortable: false
                              // },
                            ]

                            : endpoint === "Profit_Analysis_Branch"
                              ? [
                                // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                // { field: "deptno", headerName: "Dept No", flex: 0.6, sortable: false },
                                {
                                  field: "Branch", headerName: "Branch", flex: 1, sortable: false, renderCell: (params) => {
                                    if (params.row.isExpanded) {
                                      return (
                                        <Box sx={{ padding: 1, columnSpan: 20 }}>

                                          {params.row.content}

                                        </Box>
                                      );
                                    }
                                    return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                  },
                                },
                                // { field: "Month", headerName: "Month", flex: 1, sortable: false },
                                // { field: "Income", headerName: "Income", width: 110, type: "number", sortable: false },
                                // { field: "Expense", headerName: "Expense", width: 110, type: "number", sortable: false },
                                { field: "NetProfit", headerName: "Net Profit", width: 110, type: "number", sortable: false },
                                {
                                  field: "ProfitPercent",
                                  headerName: "Profit %",
                                  width: 110,
                                  type: "number"
                                  // valueFormatter: (params) =>
                                  //   params.value !== null && params.value !== undefined
                                  //     ? `${params.value.toFixed(2)}%`
                                  //     : "N/A",
                                  , sortable: false
                                },
                              ]
                              : endpoint === "Profit_Analysis_Company"
                                ? [
                                  // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                  {
                                    field: "Month", headerName: "Month", flex: 1, sortable: false, renderCell: (params) => {
                                      if (params.row.isExpanded) {
                                        return (
                                          <Box sx={{ padding: 1, columnSpan: 20 }}>

                                            {params.row.content}

                                          </Box>
                                        );
                                      }
                                      return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                    },
                                  },
                                  // { field: "Income", headerName: "Income", width: 110, type: "number", sortable: false },
                                  // { field: "Expense", headerName: "Expense", width: 110, type: "number", sortable: false },
                                  { field: "NetProfit", headerName: "Net Profit", width: 110, type: "number", sortable: false },
                                  // {
                                  //   field: "ProfitPercent",
                                  //   headerName: "Profit %",
                                  //   width: 110,
                                  //   type: "number",
                                  //   // valueFormatter: (params) =>
                                  //   //   params.value !== null && params.value !== undefined
                                  //   //     ? `${params.value.toFixed(2)}%`
                                  //   //     : "N/A",
                                  //   sortable: false
                                  // },
                                ]
                                : endpoint === "Customer_Health_Summary"
                                  ? [
                                    // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                    {
                                      field: "TotalActiveCustomers", headerName: "Total Active Customers", flex: 1, sortable: false, renderCell: (params) => {
                                        if (params.row.isExpanded) {
                                          return (
                                            <Box sx={{ padding: 1, columnSpan: 20 }}>

                                              {params.row.content}

                                            </Box>
                                          );
                                        }
                                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                      },
                                    },
                                    { field: "NewCustomers6M", headerName: "New Customers (6M)", flex: 1, sortable: false },
                                    // { field: "Inactive3M", headerName: "Inactive (3M)", flex: 1, sortable: false },
                                    // { field: "Reactivated3M", headerName: "Reactivated (3M)", flex: 1, sortable: false },
                                  ]
                                  // : endpoint === "SALES_FORCAST"
                                  //   ? [
                                  //     { field: "id", headerName: "Sl No", flex: 0.3 },
                                  //     { field: "Branch", headerName: "Branch", flex: 1 },
                                  //     { field: "Month", headerName: "Month", flex: 1 },
                                  //     { field: "ForecastSales", headerName: "Forecast Sales", flex: 1 },
                                  //     { field: "ActualSales", headerName: "Actual Sales", flex: 1 },
                                  //     { field: "AchievementPercent", headerName: "Achievement %", flex: 1 },
                                  //   ]
                                  : endpoint === "SALES_FORECAST"
                                    ? [
                                      // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                      // { field: "deptno", headerName: "Department No", flex: 1, sortable: false },
                                      {
                                        field: "ForecastMonth", headerName: "Forecast Month", flex: 1, sortable: false, renderCell: (params) => {
                                          if (params.row.isExpanded) {
                                            return (
                                              <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                {params.row.content}

                                              </Box>
                                            );
                                          }
                                          return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                        },
                                      },
                                      { field: "ForecastedSales", headerName: "Forecasted Sales", flex: 1, type: "number", sortable: false },
                                    ]
                                    : endpoint === "SALES_TARGET_ANALYSIS"
                                      ? [
                                        // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                        // { field: "Branch", headerName: "Branch", flex: 1, sortable: false },
                                        {
                                          field: "Month", headerName: "Month", flex: 1, sortable: false, renderCell: (params) => {
                                            if (params.row.isExpanded) {
                                              return (
                                                <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                  {params.row.content}

                                                </Box>
                                              );
                                            }
                                            return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                          },
                                        },
                                        { field: "ForecastSales", headerName: "Forecast Sales", flex: 1, type: "number", sortable: false },
                                        { field: "ActualSales", headerName: "Actual Sales", flex: 1, type: "number", sortable: false },
                                        { field: "AchievementPercent", headerName: "%", flex: 1, type: "number", sortable: false },
                                      ]
                                      : endpoint === "CUST_PERF_6MONTH"
                                        ? [
                                          // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                          // { field: "ACCOUNT", headerName: "Account No", flex: 1, sortable: false },
                                          {
                                            field: "ACCDESC", headerName: "Account Name", flex: 2, sortable: false, renderCell: (params) => {
                                              if (params.row.isExpanded) {
                                                return (
                                                  <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                    {params.row.content}

                                                  </Box>
                                                );
                                              }
                                              return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                            },
                                          },
                                          // { field: "LastSaleDate", headerName: "Last Sale Date", flex: 1, sortable: false },
                                          // { field: "SalesCount", headerName: "Sales Count", flex: 1, type: "number", sortable: false },
                                          { field: "TotalSales", headerName: "Total Sales", flex: 1, type: "number", sortable: false },
                                          // { field: "AvgSaleAmount", headerName: "Average Sale Amount", flex: 1, type: "number", sortable: false },
                                        ]
                                        : endpoint === "CASHFLOW"
                                          ? [
                                            // { field: "id", headerName: "Sl No", flex: 0.3, sortable: false },
                                            {
                                              field: "Month", headerName: "Month", flex: 1, sortable: false, renderCell: (params) => {
                                                if (params.row.isExpanded) {
                                                  return (
                                                    <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                      {params.row.content}

                                                    </Box>
                                                  );
                                                }
                                                return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                              },
                                            },
                                            // {
                                            //   field: "CashInflow",
                                            //   headerName: "Cash Inflow",
                                            //   flex: 1,
                                            //   type: "number"
                                            //   , sortable: false
                                            // },
                                            // {
                                            //   field: "CashOutflow",
                                            //   headerName: "Cash Outflow",
                                            //   flex: 1,
                                            //   type: "number"
                                            //   , sortable: false
                                            // },
                                            {
                                              field: "NetCashFlow",
                                              headerName: "Net Cash Flow",
                                              flex: 1,
                                              type: "number",
                                              cellClassName: (params) =>
                                                params.value < 0 ? "text-red-500" : "text-green-600", // Optional styling
                                              sortable: false
                                            },
                                          ]
                                          : endpoint === "CRM_CUSTOMER_RETENSION"
                                            ? [
                                              // { field: "id", headerName: "Sl No", flex: 0.3 },
                                              // { field: "customerId", headerName: "Customer ID", flex: 2 },
                                              {
                                                field: "customerName", headerName: "Customer Name", flex: 2, renderCell: (params) => {
                                                  if (params.row.isExpanded) {
                                                    return (
                                                      <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                        {params.row.content}

                                                      </Box>
                                                    );
                                                  }
                                                  return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                                },
                                              },
                                              { field: "lastOrder", headerName: "Last_Order", flex: 2 },
                                              // { field: "ordersCount", headerName: "OrdersCount", flex: 1, type: 'number' },
                                            ]
                                            : endpoint === "CRM_SALESMAN_PERFORM"
                                              ? [
                                                // { field: "id", headerName: "Sl No", flex: 0.3 },
                                                // { field: "salesmanId", headerName: "Salesman ID", flex: 2 },
                                                {
                                                  field: "salesmanName", headerName: "Salesman Name", flex: 2, renderCell: (params) => {
                                                    if (params.row.isExpanded) {
                                                      return (
                                                        <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                          {params.row.content}

                                                        </Box>
                                                      );
                                                    }
                                                    return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                                  },
                                                },
                                                // { field: "totalOrders", headerName: "Total Orders", flex: 1.5 },
                                                { field: "totalRevenue", headerName: "Total Sales", flex: 1.5 },
                                              ]
                                              : endpoint === "CRM_CUSTOMER_AQUI"
                                                ? [

                                                  // { field: "id", headerName: "Sl No", flex: 1 },
                                                  {
                                                    field: "month", headerName: "Month", flex: 2, renderCell: (params) => {
                                                      if (params.row.isExpanded) {
                                                        return (
                                                          <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                            {params.row.content}

                                                          </Box>
                                                        );
                                                      }
                                                      return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                                    },
                                                  },
                                                  { field: "newCustomers", headerName: "New Customers", flex: 2 },
                                                ]
                                                : endpoint === "CRM_CHURN_ANALYSIS"
                                                  ? [
                                                    // { field: "id", headerName: "Sl No", flex: 0.3 },
                                                    // { field: "customerId", headerName: "Customer ID", flex: 1 },
                                                    {
                                                      field: "customerName", headerName: "Customer Name", flex: 2, renderCell: (params) => {
                                                        if (params.row.isExpanded) {
                                                          return (
                                                            <Box sx={{ padding: 1, columnSpan: 20 }}>

                                                              {params.row.content}

                                                            </Box>
                                                          );
                                                        }
                                                        return <Box sx={{ padding: 1 }}><span style={{ backgroundColor: "#1976d2", color: "#ffffff", borderRadius: "50px", width: "15px", height: "15px", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>+</span> {params.value} </Box>;
                                                      },
                                                    },
                                                    {
                                                      field: "lastOrder",
                                                      headerName: "Last Order",
                                                      flex: 1,
                                                      renderCell: (params) => {
                                                        const lastOrderDate = parseISO(params.value);
                                                        const today = new Date();
                                                        const daysDiff = differenceInDays(today, lastOrderDate);

                                                        let icon, color, tooltipText;

                                                        if (daysDiff < 30) {
                                                          icon = <CheckCircle sx={{ color: "green" }} />;
                                                          tooltipText = "Recent Order (Less than 30 days)";
                                                        } else if (daysDiff >= 30 && daysDiff <= 365) {
                                                          icon = <Warning sx={{ color: "orange" }} />;
                                                          tooltipText = "Medium Order (Between 1 month and 1 year)";
                                                        } else {
                                                          icon = <Error sx={{ color: "red" }} />;
                                                          tooltipText = "Old Order (More than 1 year)";
                                                        }

                                                        return (
                                                          <Tooltip title={tooltipText} arrow>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                              }}
                                                            >
                                                              {format(lastOrderDate, "dd-MM-yyyy")} {icon}
                                                            </span>
                                                          </Tooltip>
                                                        );
                                                      },
                                                    },
                                                  ]
                                                  : [];

  const rows =
    endpoint === "CRM_TOP100ORDER_PRODUCTS"
      ? tableData
        ? tableData.map((item, index) => ({
          id: index + 1,
          code: item.code,
          desc: item.desc,
          totalRevenue: item.TotalRevenue,
          totalSold: item.TotalSold,
        }))
        : []
      : endpoint === "CRM_CUST_LIFETIME_VALUE"
        ? tableData
          ? tableData.map((item, index) => ({
            id: index + 1,
            account: item.account,
            accountDescription: item.accdesc,
            totalSpent: item.TotalSpent,
            totalOrders: item.TotalOrders,
            avgOrderValue: item.AvgOrderValue,
          }))
          : []


        : endpoint === "DAILYSALES_DEPT"
          ? tableData
            ? tableData.map((item, index) => ({
              id: index + 1,
              deptno: item.deptno,
              deptnodesc: item.deptnodesc,
              // SaleDate: item.SaleDate,
              SaleDate: new Date(item.SaleDate).toLocaleDateString('en-GB'),
              SalesCount: item.SalesCount,
              TotalSales: item.TotalSales,
              AvgOrderValue: item.AvgOrderValue,
            }))
            : []
          : endpoint === "MONTHLYSALES_DEPT"
            ? tableData
              ? tableData.map((item, index) => ({
                id: index + 1,
                deptno: item.deptno,
                deptnodesc: item.deptnodesc,
                SaleMonth: item.SaleMonth,
                SalesCount: item.SalesCount,
                TotalSales: item.TotalSales,
                AvgOrderValue: item.AvgOrderValue,
              }))
              : []
            : endpoint === "SAMAN_PERF_SUMM"
              ? tableData
                ? tableData.map((item, index) => ({
                  id: index + 1,
                  sman_key: item.sman_key,
                  sman_name: item.sman_name,
                  SalesCount: item.SalesCount,
                  TotalSales: item.TotalSales,
                  // LastSaleDate: item.LastSaleDate,
                  LastSaleDate: new Date(item.LastSaleDate).toLocaleDateString(), // format to local date string

                  AvgSaleAmount: item.AvgSaleAmount,
                  email: item.email,
                  phoneno: item.phoneno,
                }))
                : []
              : endpoint === "6MONTH_SALES_COMP"
                ? tableData
                  ? tableData.map((item, index) => ({
                    id: index + 1,
                    Current6MonthsSales: item.Current6MonthsSales,
                    Previous6MonthsSales: item.Previous6MonthsSales,
                    GrowthPercent: item.GrowthPercent,
                  }))
                  : []

                : endpoint === "MONTH_SALES_COMP"
                  ? tableData
                    ? tableData.map((item, index) => ({
                      id: index + 1,
                      SaleMonth: item.SaleMonth,
                      SalesCount: item.SalesCount,
                      TotalSales: item.TotalSales,
                      AvgSaleAmount: item.AvgSaleAmount,
                      PrevMonthSales: item.PrevMonthSales,
                      GrowthPercent: item.GrowthPercent,
                    }))
                    : []
                  : endpoint === "MONTH_LEAD_PIPELINE"
                    ? tableData
                      ? tableData.map((item, index) => ({
                        id: index + 1,
                        lead_stage: item.lead_stage,
                        Leads_CurrentMonth: item.Leads_CurrentMonth,
                        Leads_PreviousMonth: item.Leads_PreviousMonth,
                        BookedAmt_CurrentMonth: item.BookedAmt_CurrentMonth,
                        BookedAmt_PreviousMonth: item.BookedAmt_PreviousMonth,
                        GrowthPercent: item.GrowthPercent,
                      }))
                      : []
                    : endpoint === "New_Client_Acquisition_6mon"
                      ? tableData
                        ? tableData.map((item, index) => ({
                          id: index + 1,
                          Current6MonthsNewClients: item.Current6MonthsNewClients,
                          Current6MonthsRevenue: item.Current6MonthsRevenue,
                          Previous6MonthsNewClients: item.Previous6MonthsNewClients,
                          Previous6MonthsRevenue: item.Previous6MonthsRevenue,
                        }))
                        : []
                      : endpoint === "Top_50_Selling_Products"
                        ? tableData
                          ? tableData.map((item, index) => ({
                            id: index + 1,
                            code: item.code,
                            desc: item.desc,
                            Current6MonthsSales: item.Current6MonthsSales,
                            Previous6MonthsSales: item.Previous6MonthsSales,
                          }))
                          : []
                        : endpoint === "Monthly_Expense_analysis"
                          ? tableData
                            ? tableData.map((item, index) => ({
                              id: index + 1,
                              account: item.account,
                              accdesc: item.accdesc.trim(),
                              "2025-01": item["2025-01"] ?? 0,
                              "2025-02": item["2025-02"] ?? 0,
                              "2025-03": item["2025-03"] ?? 0,
                              "2025-04": item["2025-04"] ?? 0,
                              "2025-05": item["2025-05"] ?? 0,
                              "2025-06": item["2025-06"] ?? 0,
                              Total: null, // Total will be calculated in valueGetter of column
                            }))
                            : []
                          : endpoint === "Sales_Growth_Rate"
                            ? tableData
                              ? tableData.map((item, index) => ({
                                id: index + 1,
                                SaleMonth: item.SaleMonth,
                                TotalSales: item.TotalSales,
                                PrevMonthSales: item.PrevMonthSales ?? 0,
                                GrowthPercent: item.GrowthPercent,
                              }))
                              : []
                            : endpoint === "Profit_Analysis_Branch"
                              ? tableData
                                ? tableData.map((item, index) => ({
                                  id: index + 1,
                                  deptno: item.deptno,
                                  Branch: item.Branch,
                                  Month: item.Month,
                                  Income: item.Income,
                                  Expense: item.Expense,
                                  NetProfit: item.NetProfit,
                                  ProfitPercent: item.ProfitPercent,
                                }))
                                : []
                              : endpoint === "Profit_Analysis_Company"
                                ? tableData
                                  ? tableData.map((item, index) => ({
                                    id: index + 1,
                                    Month: item.Month,
                                    Income: item.Income,
                                    Expense: item.Expense,
                                    NetProfit: item.NetProfit,
                                    ProfitPercent: item.ProfitPercent,
                                  }))
                                  : []
                                : endpoint === "Customer_Health_Summary"
                                  ? tableData
                                    ? tableData.map((item, index) => ({
                                      id: index + 1,
                                      TotalActiveCustomers: item["Total Active Customers"],
                                      NewCustomers6M: item["New Customers (6M)"],
                                      Inactive3M: item["Inactive (3M)"],
                                      Reactivated3M: item["Reactivated (3M)"],
                                    }))
                                    : []
                                  // : endpoint === "SALES_FORCAST"
                                  //   ? tableData
                                  //     ? tableData.map((item, index) => ({
                                  //       id: index + 1,
                                  //       Branch: item.Branch,
                                  //       Month: item.Month,
                                  //       ForecastSales: item.ForecastSales,
                                  //       ActualSales: item.ActualSales,
                                  //       AchievementPercent: item.AchievementPercent,
                                  //     }))
                                  : endpoint === "SALES_FORECAST"
                                    ? tableData
                                      ? tableData.map((item, index) => ({
                                        id: index + 1,
                                        deptno: item.deptno,
                                        ForecastMonth: item.ForecastMonth,
                                        ForecastedSales: item.ForecastedSales,
                                      }))
                                      : []
                                    : endpoint === "SALES_TARGET_ANALYSIS"
                                      ? tableData
                                        ? tableData.map((item, index) => ({
                                          id: index + 1,
                                          Branch: item.Branch,
                                          Month: item.Month,
                                          ForecastSales: item.ForecastSales,
                                          ActualSales: item.ActualSales,
                                          AchievementPercent: item.AchievementPercent,
                                        }))
                                        : []
                                      : endpoint === "CUST_PERF_6MONTH"
                                        ? tableData
                                          ? tableData.map((item, index) => ({
                                            id: index + 1,
                                            ACCOUNT: item.ACCOUNT,
                                            ACCDESC: item.ACCDESC,
                                            LastSaleDate: new Date(item.LastSaleDate).toLocaleDateString(), // format to local date string
                                            SalesCount: item.SalesCount,
                                            TotalSales: item.TotalSales.toFixed(2),
                                            AvgSaleAmount: item.AvgSaleAmount.toFixed(2)
                                          }))
                                          : []
                                        : endpoint === "CASHFLOW"
                                          ? tableData
                                            ? tableData.map((item, index) => ({
                                              id: index + 1,
                                              Month: item.Month,
                                              CashInflow: item.CashInflow,
                                              CashOutflow: item.CashOutflow,
                                              NetCashFlow: item.NetCashFlow,
                                            }))
                                            : []
















                                          : endpoint === "CRM_CUSTOMER_RETENSION"
                                            ? tableData
                                              ? tableData.map((item, index) => ({
                                                id: index + 1,
                                                customerId: item.CustomerID,
                                                customerName: item.CustomerName,
                                                // lastOrder: item.Last_Order,

                                                lastOrder: new Date(item.Last_Order).toLocaleDateString('en-GB'), // format to local date string

                                                ordersCount: item.OrdersCount,
                                              }))
                                              : []
                                            : endpoint === "CRM_CHURN_ANALYSIS"
                                              ? tableData
                                                ? tableData.map((item, index) => ({
                                                  id: index + 1,
                                                  customerId: item.CustomerID,
                                                  customerName: item.CustomerName,
                                                  lastOrder: item.Last_Order,
                                                }))
                                                : []
                                              : endpoint === "CRM_SALESMAN_PERFORM"
                                                ? tableData
                                                  ? tableData.map((item, index) => ({
                                                    id: index + 1,
                                                    salesmanId: item.SalespersonID,
                                                    salesmanName: item.SalespersonName,
                                                    totalOrders: item.TotalOrders,
                                                    totalRevenue: item.TotalSales,
                                                  }))
                                                  : []
                                                : endpoint === "CRM_CUSTOMER_AQUI"
                                                  ? tableData
                                                    ? tableData.map((item, index) => ({
                                                      id: index + 1,
                                                      month: item.Month,
                                                      newCustomers: item.NewCustomers,
                                                    }))
                                                    : []
                                                  : [];

  const getRowsWithExpansion = () => {
    const result = [];
    rows.forEach((row) => {
      result.push(row);
      if (row.id === expandedRow) {
        result.push({
          id: `${row.id}-expanded`,
          isExpanded: true,
          parentId: row.id,
          content: Object.keys(row).map((item) => <p>{item}{""}<span style={{ fontWeight: "600", marginLeft: "10px" }}>{row[item]}</span></p>)
        });
      }
    });
    return result;
  };


  const getRowHeight = (params) => {
    if (params.model?.isExpanded) {
      return 'auto';
    }
    return 'auto'; // Let the row size to fit content (if needed)
  };

  return (
    <div className="w-full overflow-x-auto">

      <div className="flex justify-between items-center mb-2">
        <div className="flex justify-left gap-4 items-center mb-2">

          {selectedBranch && (
            <div className="mt-2 text-sm text-gray-700">
              Selected Branch:{" "}
              <strong>
                {selectedBranch.deptnodesc} ({selectedBranch.DEPTNO})
              </strong>
            </div>
          )}
        </div>

        <select
          value={selectedBranch?.DEPTNO || ""}
          onChange={(e) => setSelectedBranchCode(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          {branches?.map((branch) => (
            <option key={branch.DEPTNO} value={branch.DEPTNO}>
              {branch.deptnodesc}
            </option>
          ))}
        </select>
      </div>

      {(rows && columns) ?
        <Paper sx={{}}>

          <DataGrid
            disableColumnMenu
            disableColumnFilter
            disableColumnSelector

            checkboxSelection={false}
            rows={getRowsWithExpansion()}
            getRowHeight={getRowHeight}
            columns={columns}
            pagination
            paginationMode="server"
            page={page}
            pageSizeOptions={[pageSize]}
            rowCount={rows.length}
            onPageChange={(newPage) => setPage(newPage)}
            onRowClick={handleRowClick}
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                fontFamily: "'Figtree', sans-serif",
                background: "#27446A",
                color: "#F8F8F8",
              },
              "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                color: "#FFFFFF", // hide the "Select All" label space

              },
              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                color: "#FFFFFF", // unselected checkbox color

              },
              "& .MuiDataGrid-columnHeaderCheckbox .Mui-checked": {
                color: "#FFFFFF", // selected checkbox color
              },
              "& .MuiDataGrid-cell": {
                padding: "1px 2px",
                fontFamily: "'Figtree', sans-serif",
              },
            }}
          />
        </Paper>

        :
        <div>No data found</div>
      }
    </div>

  );
};

export default DataTable;